<template>
	<div id="app" data-app>
		<section class="frame" id="parent">
			<v-app>
				<transition :name="transitionName" mode="out-in">
					<router-view />
				</transition>
			</v-app>
		</section>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

import { Intercom } from '@capacitor-community/intercom'

const intercom = new Intercom()

export default {
	components: {},
	name: 'app',
	data() {
		return {
			transitionName: '',
			hashHistory: [window.location.hash],
			historyLength: window.history.length
		}
	},
	computed: {
		...mapGetters(['user'])
	},
	methods: {
		onSearch(query) {
			this.onShowResults({ query })
		},
		onShowDetails(inst) {
			this.$router.push({
				name: 'details',
				props: { uuid: inst.uuid },
				params: { uuid: inst.uuid, inst }
			})
		},
		onShowResults(params) {
			this.$router.push({
				name: 'results',
				params
			})
		}
	},
	watch: {
		$route(to) {
			var hash = window.location.hash
			var length = window.history.length
			if (this.hashHistory.length && this.historyLength === length) {
				if (this.hashHistory[this.hashHistory.length - 2] === hash) {
					this.hashHistory = this.hashHistory.slice(0, -1)
					this.transitionName = 'slide-right'
				} else if (
					this.hashHistory[this.hashHistory.length - 1] === hash
				) {
					this.hashHistory.push(hash)
				} else {
					this.hashHistory.push(hash)
					this.transitionName = 'slide-left'
				}
			} else {
				this.hashHistory.push(hash)
				this.historyLength = length
			}

			if (to.params.direction === 'back') {
				this.transitionName = 'slide-right'
			} else if (to.params.direction === 'forward') {
				this.transitionName = 'slide-left'
			} else if (to.params.direction === 'up') {
				this.transitionName = 'slide-up'
			} else if (to.params.direction === 'down') {
				this.transitionName = 'slide-down'
			} else if (to.params.direction === 'fade') {
				this.transitionName = 'fade'
			}
		},
		user(val) {
			if (process.env.VUE_APP_TYPE === 'android') {
				if (val.id) {
					intercom.updateUser({
						user_id: val.id,
						name: `${val.first_name} ${val.last_name}`,
						email: val.email
					})
				}
			}
			if (process.env.VUE_APP_TYPE === 'ios' && val.id) {
				intercom.registerUserWithEmail({ email: val.email })
			}
		}
	},
	created() {
		if (
			process.env.VUE_APP_TYPE === 'android' ||
			process.env.VUE_APP_TYPE === 'ios'
		) {
			intercom.displayLauncher()
			intercom.registerUnidentifiedUser()
		}
	},
	mounted() {
		this.$root.$on('search', (query) => this.onShowResults({ query }))
		this.$root.$on('searchDetail', (inst) => this.onShowDetails(inst))
		this.$root.$on('localSearch', (query) => this.onSearch(query))
	}
}
</script>

<style lang="scss">
* {
	box-sizing: border-box;
}

body,
html {
	margin: 0px;
	padding: env(safe-area-inset-top) env(safe-area-inset-right)
		env(safe-area-inset-bottom) env(safe-area-inset-left) !important;
	background: $bone;
	font-family: 'Open Sans', Helvetica, Arial, sans-serif;
	color: $dark-grey;
	height: 100%;

	@media screen and (max-width: 480px) {
		.swal2-shown {
			overflow-y: visible !important;
		}
	}
}
#app {
	min-height: 100vh;

	font-family: 'Work Sans', Helvetica, Arial, sans-serif;
	@media screen and (max-width: 480px) {
		height: 100%;
	}
	.v-application {
		background: $bone;
	}
}
.frame {
	max-width: 480px;
	margin: 0px auto 0px;
	border-radius: 14px;
	position: relative;
	height: 100%;
	@media screen and (max-width: 960px) {
		max-width: 480px;
	}
	@media screen and (max-width: 486px) {
		margin-top: 0px;
	}
}
.slide-left-enter,
.slide-right-leave-active {
	transform: translate(100%, 0);
	opacity: 0;
	backface-visibility: hidden;
	z-index: 1;
}
.slide-left-leave-active,
.slide-right-enter {
	transform: translate(-100%, 0);
	opacity: 0;
	backface-visibility: hidden;
	z-index: 1;
}
.slide-left-enter-active,
.slide-right-enter-active {
	position: absolute;
	@media screen and (max-width: 480px) {
		top: 0px;
	}
}
.slide-left-enter-active,
.slide-right-leave-active,
.slide-right-enter-active,
.slide-left-leave-active {
	transition: all 250ms ease-in-out;
}
.slide-up-enter,
.slide-down-leave-active {
	transform: translate(0, 100%);
	opacity: 0;
	backface-visibility: hidden;
	z-index: 1;
}
.slide-up-leave-active,
.slide-down-enter {
	transform: translate(0, -100%);
	opacity: 0;
	backface-visibility: hidden;
	z-index: 1;
}
.slide-up-enter-active,
.slide-down-enter-active {
	position: absolute;
	top: -20px;
	@media screen and (max-width: 480px) {
		top: 0px;
	}
}
.slide-up-enter-active,
.slide-down-leave-active,
.slide-down-enter-active,
.slide-up-leave-active {
	transition: all 0.25s ease-in-out;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
